import { render, staticRenderFns } from "./orders__list.vue?vue&type=template&id=6b1426ea"
import script from "./orders__list.vue?vue&type=script&lang=js"
export * from "./orders__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports